export default {"src":"/login-app/[GIT_HASH]/_next/static/media/data_type.9f9e0039.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};